var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGraphsArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 8.8,
    height: 15.393,
    viewBox: "0 0 8.8 15.393",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-arrow-back",
    "data-name": "Icon ionic-ios-arrow-back",
    d: "M2.653,7.694l5.824-5.82A1.1,1.1,0,0,0,6.919.321L.32,6.915A1.1,1.1,0,0,0,.288,8.432l6.626,6.64a1.1,1.1,0,1,0,1.558-1.553Z",
    transform: "translate(8.8 15.393) rotate(180)",
    fill: "#fff"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraphsArrow);
export default __webpack_public_path__ + "static/media/GraphsArrow.1b6293f35fb39f5a739345a0b075e6b5.svg";
export { ForwardRef as ReactComponent };